import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  commonTranslations,
  LANGUAGE_STORAGE_KEY,
  DEFAULT_LANGUAGE,
  resolveLanguage,
} from '@certara/common-react-components/i18n';

import loadEn from './locales/en/load.json';
import loadPtBR from './locales/pt-BR/load.json';
import loadEs from './locales/es/load.json';
import loadJa from './locales/ja/load.json';

function getSavedLanguage(): string {
  try {
    return resolveLanguage(localStorage.getItem(LANGUAGE_STORAGE_KEY));
  } catch {
    return DEFAULT_LANGUAGE;
  }
}

const savedLanguage = getSavedLanguage();

i18n.use(initReactI18next).init({
  resources: {
    en: { ...commonTranslations.en, load: loadEn },
    'pt-BR': { ...commonTranslations['pt-BR'], load: loadPtBR },
    es: { ...commonTranslations.es, load: loadEs },
    ja: { ...commonTranslations.ja, load: loadJa },
  },
  lng: savedLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  defaultNS: 'load',
  ns: ['common', 'load'],
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

try {
  document.documentElement.lang = savedLanguage;
} catch {
  // Test environment: document may not be fully available
}

i18n.on('languageChanged', (lng: string) => {
  try {
    document.documentElement.lang = lng;
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  } catch {
    // Test/build environment
  }
});

try {
  window.addEventListener('storage', (e: StorageEvent) => {
    if (e.key === LANGUAGE_STORAGE_KEY && e.newValue) {
      const lng = resolveLanguage(e.newValue);
      if (lng !== i18n.language) {
        i18n.changeLanguage(lng);
      }
    }
  });
} catch {
  // Test/SSR environment
}

export default i18n;
